import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PermissionAction {
  value: string; // formato: "resource:action"
  label: string;
  description?: string;
}

export interface PermissionGroup {
  resource: string;
  resourceLabel: string;
  category: string;
  actions: PermissionAction[];
}

export interface PermissionsState {
  permissions: PermissionGroup[];
  selectedPermissions: string[]; // Array de valores "resource:action"
  loading: boolean;
  error: string | null;
}

const initialState: PermissionsState = {
  permissions: [],
  selectedPermissions: [],
  loading: false,
  error: null,
};

const rbacPermissionsSlice = createSlice({
  name: 'rbacPermissions',
  initialState,
  reducers: {
    fetchPermissionsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchPermissionsSuccess: (state, action: PayloadAction<PermissionGroup[]>) => {
      state.loading = false;
      state.permissions = action.payload;
    },
    fetchPermissionsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedPermissions: (state, action: PayloadAction<string[]>) => {
      state.selectedPermissions = action.payload;
    },
    togglePermission: (state, action: PayloadAction<string>) => {
      const permission = action.payload;
      const index = state.selectedPermissions.indexOf(permission);
      if (index === -1) {
        state.selectedPermissions.push(permission);
      } else {
        state.selectedPermissions.splice(index, 1);
      }
    },
    clearSelectedPermissions: (state) => {
      state.selectedPermissions = [];
    },
  },
});

export const {
  fetchPermissionsStart,
  fetchPermissionsSuccess,
  fetchPermissionsFailure,
  setSelectedPermissions,
  togglePermission,
  clearSelectedPermissions,
} = rbacPermissionsSlice.actions;

// Action creator para el saga
export const fetchPermissions = () => ({
  type: 'rbacPermissions/fetchPermissions',
});

export const rbacPermissionsReducer = rbacPermissionsSlice.reducer;
export default rbacPermissionsReducer;

